import React, {useState} from "react";
import "./style.css";

const OrderMenuList = (props) => {
  const [tabs, setTabs] = useState(props.menuData);
  const [draggedIdx, setDraggedIdx] = useState(null);

  const enabledTabs = tabs.filter(tab => tab.enabled);
  const dropZones = [];
  for (let i = 0; i <= enabledTabs.length; i++) {
    dropZones.push(
      <div
        key={`drop-${i}`}
        onDragOver={(e) => e.preventDefault()}
        onDrop={() => onDrop(i)}
        style={{ width: '20px', background: 'rgba(0,0,0,0.1)', minHeight: '40px' }}
      ></div>
    );
    if (i < enabledTabs.length) {
      const tab = enabledTabs[i];
      const originalIdx = tabs.indexOf(tab);
      dropZones.push(
        <div
          key={tab.pageName}
          draggable
          onDragStart={() => onDragStart(originalIdx)}
          style={{
            padding: "10px 10px",
            color: draggedIdx === originalIdx ? "white" : "#1a345e",
            cursor: "grab",
            userSelect: "none",
            margin: "10px 8px",
            border: draggedIdx === originalIdx ? "2px solid #1a345e" : "2px solid transparent",
            borderRadius: "4px",
            fontWeight: "bold",
            fontSize: "18px",
            backgroundColor: "rgb(47, 158, 206)"
          }}
        >
          {tab.displayName}
        </div>
      );
    }
  }

  const onDragStart = (idx) => setDraggedIdx(idx);
  const onDrop = (targetIdx) => {
    if (draggedIdx === null) return;
    const updated = [...tabs];
    const [draggedTab] = updated.splice(draggedIdx, 1);
    let insertIdx;
    if (targetIdx < enabledTabs.length) {
      insertIdx = tabs.indexOf(enabledTabs[targetIdx]);
    } else {
      insertIdx = tabs.length;
    }
    updated.splice(insertIdx, 0, draggedTab);
    const orderedTabs = updated.map((tab, i) => ({...tab, sortOrder: i+1}));
    setTabs(orderedTabs);
    if (props.setMenuData) props.setMenuData(orderedTabs);
    setDraggedIdx(null);
  };

  return (
    <div className="mt-3">
      <nav
        style={{
          background: "white",
          borderBottom: "2px solid #1a345e",
          padding: "8px 0",
          display: "flex",
          fontFamily: "Arial, sans-serif",
          backgroundColor: "rgb(240, 240, 240)"
        }}
      >
        {dropZones}
      </nav>
    </div>
  );
};

export default OrderMenuList;



// WEBPACK FOOTER //
// ./src/mi-app/adminPanel/Menu Management/OrderMenuList.js